// extracted by mini-css-extract-plugin
export default {"price":"HostingPackPrice-price_gMUmV"};